import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialogClose, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { ClientStatusService } from '../../../status/client-status.service';
import { IStatusType } from '../../../../model/common.model';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { NgClass, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EcaMultiSelectModule, EcaFormColumnModule } from '@drc-eca/eca-components-lib';

@Component({
    selector: 'app-view-outage-updates-modal',
    standalone: true,
    templateUrl: './view-outage-updates-modal.component.html',
    styleUrls: ['./view-outage-updates-modal.component.scss'],
    imports: [ MatIcon, MatButton, MatDialogModule, MatDialogClose, MatDialogTitle, MatDialogActions, NgClass, DatePipe, MatDialogModule, EcaMultiSelectModule, EcaFormColumnModule, MatButtonModule, FormsModule, ReactiveFormsModule ]
})
export class ViewOutageUpdatesModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ViewOutageUpdatesModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  outage: any = {};
  clientStatusSvc: ClientStatusService;
  updates: any[] = [];
  serviceSeverityList: IStatusType[] = [];

  constructor() {
    const data = this.data;

    this.outage = data.outage;
    this.clientStatusSvc = data.clientStatusSvc;
  }

  ngOnInit(): void {
    this.clientStatusSvc.doGet(`admin/outageupdate/${this.outage.primaryKeyPart}`).subscribe((data: any[]) => {
      this.updates = this.clientStatusSvc.sortArray((data || []), 'createTime', 'desc');
    },
      () => {
        this.updates = [];
      });
    this.clientStatusSvc.getServiceStatusList().subscribe(data=>{
      this.serviceSeverityList = data || [];
    })
  }

  getClass = (name: string) => {
    const status = this.serviceSeverityList.findIndex(s => s.statusName == name);
    if (status > -1) {
      return this.serviceSeverityList[status].statusColorCode;
    } else {
      return this.clientStatusSvc.getClass(name);
    }
  }

}
